export default __webpack_public_path__ + "static/media/bg-home.3f33120c.svg";